<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <label class="done">Registration</label>
                                    <label class="done active">Payment</label>
                                    <label class="passive" href="#">Visa Form</label>
                                    <label class="passive" href="#">Documents</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 offset-md-1">
                            <div class="reg-form payment top124">
                                <div class="reg-completed">
                                    <div class="form-group row">
                                        <div v-if="paymentValid" class="payment-box bt32">
                                            <h2>Payment is Complete</h2>
                                            <p>
                                                {{this.$route.query.p6}} Pula fee for {{this.$route.query.p8 }} paid.
                                            </p>
                                            <p>
                                                The receipt number is: {{receipt }}
                                            </p>
                                        </div>
                                        <div v-else class="payment-box bt32">
                                            <h2>There may be a problem with your payment. Please check your email for receipt. Do not re-register your application!!! Instead exit and re-open your browser, then click Continue Submission</h2>
                                        </div>
                                    </div>

                                    <div class="reg-div"></div>

                                    <div v-if="paymentUpdated" class="form-group row">
                                        <p class="continue-msg">Click on fill the visa form to continue</p>
                                        <div class="col-sm-12 submit-row">
                                            <router-link to="/appdetails">
                                                <button type="submit" class="btn-submit">Fill the Visa Form</button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Registration</label>
                        <label class="active">Payment</label>
                        <label class="passive" href="#">Visa Form</label>
                        <label class="passive" href="#">Documents</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 app top64">
                    <div class="reg-form payment">
                        <div class="reg-completed">
                            <div class="form-group row">
                                <div v-if="paymentValid" class="payment-box bt32">
                                    <h2>Payment is Complete</h2>
                                    <p>
                                        {{this.$route.query.p6}} Pula fee for {{this.$route.query.p8 }} paid.
                                    </p>
                                    <p>
                                        The receipt number is: {{receipt }}
                                    </p>
                                </div>
                                <div v-else class="payment-box bt32">
                                    <h2>There may be a problem with your payment. Please check your email for receipt. Do not re-register your application!!! Instead exit and re-open your browser, then click Continue Submission</h2>
                                </div>

                            </div>

                            <div class="reg-div"></div>

                            <div v-if="paymentUpdated" class="form-group row">
                                <p class="continue-msg">Click on fill the visa form to continue</p>
                                <div class="col-sm-12 submit-row">
                                    <router-link to="/appdetails">
                                        <button type="submit" class="btn-submit">Fill the Visa Form</button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'PaymentOK',

        data: () => ({
            model: {},
            paymentUpdated: true,
            paymentValid: true,
            receipt: ''
        }),
        mounted() {
            console.log("and the referrer is.. - " + document.referrer);
            var ppp = "parameters: p8=" + this.$route.query.p8 + ", p3=" + this.$route.query.p3 + ", p2=" + this.$route.query.p2;
            console.log(ppp);
            var p3 = this.$route.query.p3;
            var endIdx = p3.indexOf("APPROVED");
            this.receipt = this.$route.query.p3.slice(0, endIdx);
            // remove referrer check because of the switch to the new gateway, Nov 9 2022
            //if (document.referrer.includes("www.vcs.co.za")) {
                //this.postTimeStampLog();
                //this.postParameters();
                //this.update()
            //} else {
            //    this.paymentValid = false;
            //    this.postErrorLog();
        
            // old old old 
            /*if (document.referrer == "https://www.vcs.co.za/" || document.referrer == "https://www.vcs.co.za")
                this.update()
            else {
                this.paymentValid = false;
                this.postLog();
            }*/
                
        },
        computed: {
           
        },
        methods: {
            async update() {
              
                try {
                    this.paymentValid = false;
                    const response = await fetch(this.$apiip + '/api/v1/application/' + this.$route.query.p8.slice(-13) + '/' + this.$route.query.p2 + '/' + this.$route.query.p3 +'/paymentok', {
                            method: 'POST',
                            body: JSON.stringify(this.model),
                            headers: { 'Content-type': 'application/json; charset=UTF-8' },
                        })
                    const data = await response.json()
                    if (data.Status == 0) {
                        this.receipt = data.AppId;
                        this.paymentUpdated = true;
                        this.paymentValid = true;
                    }
                   
                }catch(error){
                }
            },

            async postParameters() {
                var logtext = "paymentok params. p8: " + this.$route.query.p8 + ", sliced: " + this.$route.query.p8.slice(-13) + ", p2: " + this.$route.query.p2 + ", p3: " + this.$route.query.p3;
                const response = await fetch(this.$apiip + '/api/v1/application/clientlog', {
                    method: 'POST',
                    body: JSON.stringify(logtext),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
            },

            async postErrorLog() {
                var logtext = "coza failed because of wrong referrer which is: " + document.referrer + ", app no: " + this.$cookie.get('eVisaAppID');
                const response = await fetch(this.$apiip + '/api/v1/application/clientlog', {
                    method: 'POST',
                    body: JSON.stringify(logtext),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
            },

            async postTimeStampLog() {
                var logtext = "page paymentok loaded. App no: " + this.$cookie.get('eVisaAppID');
                const response = await fetch(this.$apiip + '/api/v1/application/clientlog', {
                    method: 'POST',
                    body: JSON.stringify(logtext),
                    headers: { 'Content-type': 'application/json; charset=UTF-8' },
                })
            }

       }
    }
</script>
